import { render, staticRenderFns } from "./SupportUsNew.vue?vue&type=template&id=feaf52ba&scoped=true&"
import script from "./SupportUsNew.vue?vue&type=script&lang=js&"
export * from "./SupportUsNew.vue?vue&type=script&lang=js&"
import style0 from "./SupportUsNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SupportUsNew.vue?vue&type=style&index=1&id=feaf52ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaf52ba",
  null
  
)

export default component.exports